import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { REAL_TIME_ROUTES } from '@constants'
import RealTimeTable from './Table'
import RealTimeFilters from './Filters'
import { useSearchParams, useLocation } from 'react-router-dom'
import { userComesFromUrl, isSearching, idSearch, clearSignals } from 'Pages/RealTimeHistory/RealTime/@signals'
import { isLoadingCommonFilters, resetCommonFilters } from '@signals'
import { AppStartHint, searchStartHintProps } from '@components'
import RealTimeLinearProgress from 'Pages/RealTimeHistory/RealTime/LinearProgress'
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from './VirtualTour'
import RealTimeDemoData from './VirtualTour/DemoData'
import { batch } from '@preact/signals-react'


export default function RealTimePage() {
	const [tourActive, setTourActive] = useState(false)
	const [searchParams] = useSearchParams()
	const location = useLocation()

	useEffect(() => {
		const id = searchParams.get('idSearch')
		if(id) {
			batch(() => {
				userComesFromUrl.value = true
				isSearching.value = true
				idSearch.value = id
			})
		} else {
			clearSignals()
			resetCommonFilters()
		}
		return () => {
			clearSignals()
		}
	}, [location.search])

	return <PageWrapper
		head={`DS Rentacar | ${REAL_TIME_ROUTES.TITLE}`}
		title={REAL_TIME_ROUTES.TITLE}
		subtitle={REAL_TIME_ROUTES.SUBTITLE}
		isEmpty={false}
		filters={<RealTimeFilters />}
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		{!idSearch.value && !isSearching.value && !isLoadingCommonFilters.value && !tourActive && <AppStartHint
			{...searchStartHintProps}
			description="Choose your filters above and click Search to launch a live search"
		/>}
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<RealTimeLinearProgress/>
			</Grid>
			<Grid item xs={12}>
				<RealTimeTable />
			</Grid>
		</Grid>
		{tourActive && <RealTimeDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
